import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  UnlockThisDeal: 'Unlock This Deal',
  becomeAPartner: 'Become a partner',
  becomeAPartnerDetail:
    'Do you want to be listed? Fill out the form below to get in touch with our partnership team.',
  benefitValue: 'BENEFIT VALUE',
  businessPurposeStatement:
    'Everything we do is to make it easier to start a business and provide you with the tools to succeed.',
  company: 'Company',
  companyLogo: 'Logo URL',
  companyName: 'Name',
  companyWebsite: 'Website',
  contact: 'Contact',
  listing: 'Listing',

  listingDescription: 'Description',
  listingDescriptionPlaceholder: '',
  listingName: 'Name',
  listingNamePlaceholder: 'Example: 10% off annual subscriptions',
  listingRedemption: 'Redemption Details',
  listingRedemptionDescription:
    'Add any UTM links, offer codes, eligibility requirements or instructions on how to redeem the offer.',
  loginToRedeemOffer: 'Only available to registered customers',
  marketplace: 'Marketplace',
  offerAvailabilityCondition: 'This deal is exclusively available to {0}.',
  peopleAlsoLikedTheseOffers: 'People also like these offers',
  popularCategories: 'Popular categories',
  screenshots: 'screenshots',
  seoBecomeAPartnerDescription:
    'Do you want to be listed? Fill out the form below to get in touch with our partnership team.',
  seoBecomeAPartnerTitle: 'Become a partner',
  seoDescription:
    'Get access to the best Startup & Entrepreneur discounts. Instantly save thousands of pounds on software and services. ',
  seoTitle: 'Get access to the best startup deals and discounts | Hoxton Mix',
  staffPicks: 'Featured',
  staffPicks2: 'Featured Offers',
  staffPicksStatement:
    'Hand picked apps and services to help save you time and money.',
  submit: 'Submit',
  successMessage:
    '<h5 class="my-2">Thank you for your submission!</h5><p class="my-2">We appreciate your interest. A member of our team has received your form and will be in contact with you shortly.</p>',
  wantAFeatureOrService: 'Want to feature an app or service?',
  weArepassionateAboutentrepreneurship:
    'We’re passionate <br class="d-none d-lg-block" /> about entrepreneurship',
}
export const marketplaceStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
